export default __webpack_public_path__ + "static/media/arrow.ec29fb5a.svg";